"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowTransitionInput = exports.WorkflowTransitionDec = exports.WorkflowTransition = void 0;
const function_1 = require("fp-ts/lib/function");
const D = __importStar(require("io-ts/lib/Decoder"));
const codecs_1 = require("./codecs");
class WorkflowTransition {
}
exports.WorkflowTransition = WorkflowTransition;
exports.WorkflowTransitionDec = (0, function_1.pipe)(D.struct({
    workflowId: D.number,
    transitionNumber: D.number,
    type: D.string,
    data: D.struct({}),
    from_state: D.string,
    to_state: D.string,
    createdBy: D.string,
    createdAt: codecs_1.DateFromISOString,
}), D.withMessage(() => 'WorkflowTransition'));
const buildWorkflowTransitionInput = (data = {}) => {
    return {
        type: 'UNKNOWN',
        data: {},
        createdBy: 'TANEI001',
        workflow: undefined,
        ...data,
    };
};
exports.buildWorkflowTransitionInput = buildWorkflowTransitionInput;
//# sourceMappingURL=WorkflowTransition.dto.js.map